.common-page {
  min-height: 57vw;
}

.page-loading-indicator {
  padding: 2rem 0 8rem;
}

.not-found {
  margin: 0 auto;
  max-width: 50ch;
}

.not-found-link {
  color: var(--rds-foreground-primary);
  text-decoration: underline;
}

.common-page-swimlane-wrapper {
  position: relative;
  z-index: 1;
}
